import styled from 'styled-components'


export const ButtonInformes = styled.a`
    background-color: #0E79f1;
    color: #ffffff;
    border: 1px solid #0E79f1;
    border-radius: 15px;
    padding: .6em 1.5em; 
    box-shadow: 0px 3px 6px #00000029;
    &:hover{
        background-color: #ffffff;
        color: #0E79f1;
    }
`;

export const ButtonEnfoque = styled.a`
    background-color: #F0634A;
    color: #ffffff;
    border: 1px solid #F0634A;
    border-radius: 15px;
    padding: .6em 1.5em; 
    box-shadow: 0px 3px 6px #00000029;
    &:hover{
        background-color: #ffffff;
        color: #F0634A;
    }
`;

export const ButtonEspecialidad = styled.a`
    //background-color: #ff7275;  
    background-color: #F46442;
    color: #ffffff;
    //border: 1px solid #ff7275;
    border: 1px solid #F46442;
    border-radius: 15px;
    padding: .6em 1.5em; 
    box-shadow: 0px 3px 6px #00000029;
    &:hover{
        background-color: #ffffff;
        color: #F46442;
    }
`;

export const ButtonGlobal = styled.a`
    background-color: #D69447;
    color: #ffffff;
    border: 1px solid #D69447;
    border-radius: 15px;
    padding: .6em 1.5em; 
    box-shadow: 0px 3px 6px #00000029;
    &:hover{
        background-color: #ffffff;
        color: #D69447;
    }
`;

export const ButtonGuion = styled.a`
    background-color: #0099da;
    color: #ffffff;
    border: 1px solid #0099da;
    border-radius: 15px;
    padding: .6em 1.5em; 
    box-shadow: 0px 3px 6px #00000029;
    &:hover{
        background-color: #ffffff;
        color: #0099da;
    }
`;

export const ButtonArte = styled.a`
    background-color: #000000;
    color: #ffffff;
    border: 1px solid #000000;
    border-radius: 15px;
    padding: .6em 1.5em; 
    box-shadow: 0px 3px 6px #00000029;
    &:hover{
        background-color: #ffffff;
        color: #000000;
    }
`;

export const ButtonNegocios = styled.a`
    background-color: #f15b5b;
    color: #ffffff;
    border: 1px solid #f15b5b;
    border-radius: 15px;
    padding: .6em 1.5em; 
    box-shadow: 0px 3px 6px #00000029;
    &:hover{
        background-color: #ffffff;
        color: #f15b5b;
    }
`;

export const ButtonEstudios = styled.a`
    background-color: #72bf44;
    color: #ffffff;
    border: 1px solid #72bf44;
    border-radius: 15px;
    padding: .6em 1.5em; 
    box-shadow: 0px 3px 6px #00000029;
    &:hover{
        background-color: #ffffff;
        color: #72bf44;
    }
`;

export const ButtonVivienda = styled.a`
    background-color: #27bdbe;
    color: #ffffff;
    border: 1px solid #27bdbe;
    border-radius: 15px;
    padding: .6em 1.5em; 
    box-shadow: 0px 3px 6px #00000029;
    &:hover{
        background-color: #ffffff;
        color: #27bdbe;
    }
`;

export const ButtonFood = styled.a`
    background-color: #faa519;
    color: #ffffff;
    border: 1px solid #faa519;
    border-radius: 15px;
    padding: .6em 1.5em; 
    box-shadow: 0px 3px 6px #00000029;
    &:hover{
        background-color: #ffffff;
        color: #faa519;
    }
`;

export const ButtonWhite = styled.a`
    background-color: #ffffff;
    color: #000000;
    border: 1px solid #ffffff;
    border-radius: 15px;
    padding: .6em 1.5em; 
    box-shadow: 0px 3px 6px #00000029;
    &:hover{
        background-color: #000000;
        color: #ffffff;
    }
`;
